import React from 'react';
import { Truck, Clock } from 'lucide-react';

export const TurnaroundBadge = ({ className = '' }) => (
  <div
    className={`inline-flex items-center gap-1.5 bg-[#CE8946]/20 text-[#CE8946] text-xs font-semibold px-3 py-1.5 rounded-full ${className}`}
    data-testid="turnaround-badge"
  >
    <Truck className="h-3.5 w-3.5" /> Emergency shipping available
  </div>
);

export const TurnaroundNote = ({ className = 'text-white/55' }) => (
  <p className={`text-sm flex items-center gap-1.5 ${className}`} data-testid="turnaround-note">
    <Clock className="h-3.5 w-3.5 text-[#CE8946] flex-shrink-0" /> Most rebuilds ship back in 5 to 10 days.
  </p>
);

export default TurnaroundBadge;
